import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// プラグイン登録
gsap.registerPlugin(ScrollTrigger);

export default function scrollFade() {
  
  /***************************************************************************
   * 1. 通常のフェードアップ（.fade-up）
   ***************************************************************************/
  const fadeTargets = document.querySelectorAll('.fade-up');

  if (fadeTargets.length > 0) {
    fadeTargets.forEach((target) => {
      gsap.fromTo(target,
        // ① 初期状態
        {
          y: 80,
          autoAlpha: 0,
        },
        // ② アニメーション後
        {
          y: 0,
          autoAlpha: 1,
          duration: 1.0,
          ease: "power2.out",
          scrollTrigger: {
            trigger: target,
            start: "top 85%", // 画面の85%の位置で開始
            toggleActions: "play none none none",
          },
        }
      );
    });
  }

  /***************************************************************************
   * 2. 図形アニメーション（.circle, .square）
   * ・少し小さいサイズから元のサイズへ
   * ・複数ある場合はタイミングをずらす
   * ・fade-upより少し遅れて開始
   ***************************************************************************/
  
  // 対象要素をまとめて指定
  const shapeSelector = '.circle, .square';
  const shapeTargets = document.querySelectorAll(shapeSelector);

  // 要素がある場合のみ実行（エラー回避）
  if (shapeTargets.length > 0) {
    
    // ① まず初期状態をセット（アニメーション開始前に隠しておく）
    gsap.set(shapeTargets, { 
      scale: 0.7,   // 70%の大きさにしておく
      autoAlpha: 0  // 透明にしておく
    });

    // ② バッチ処理（画面に入ってきた要素をまとめて制御）
    ScrollTrigger.batch(shapeTargets, {
      start: "top 85%", // fade-upと同じ位置で検知開始
      
      // 画面に入った時のアニメーション
      onEnter: (batch) => {
        gsap.to(batch, {
          scale: 1,        // 元のサイズに戻す
          autoAlpha: 1,    // 不透明にする
          duration: 0.8,
          ease: "back.out(1.7)", // 少しボヨンと弾むような動き（自然にしたい場合は "power2.out" に変更）
          
          // ▼ ここでズラしと遅延を設定
          stagger: 0.15,   // 複数同時に画面にある場合、0.15秒ずつずらして実行
          delay: 0.2,      // fade-upより0.2秒遅らせてスタート
          
          overwrite: true  // 予期せぬ競合を防ぐ
        });
      },
      
      // 一度表示したらリセットしない設定（play none none none相当）
      once: true 
    });
  }
}